import React from "react";

import HeroSection from "./sections/hero/Hero";
import CategorySection from "./sections/category/Categories";
import Services from "./sections/services/Services";
import RecommendedVendor from "./sections/recommendedVendor/RecommendedVendor";

const Home = () => {
  return (
    <>
      <HeroSection />
      <CategorySection />
      <Services />
      <RecommendedVendor />
      
    </>
  );
};

export default Home;
